export default __webpack_public_path__ + "static/david-9fdeb20c46a65d49a8a24683bab74d36.png";